import React, { Component, Suspense, useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Card, Form, Row, Col, Button, Dropdown, ButtonGroup, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowLeft, faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { CodingWorksheetService } from '../../services';
import stateHelpers from '../../utilities/stateHelpers';

import * as WorksheetControls from '../../controls/worksheetcontrols';


class CodingWorksheet extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { codingEventWorksheet: { status: null}, worksheet: { sections: [] }, worksheetAnswers: {}, currentPage: 0, pageCount: 0, pages: [] };
        this.buildWorksheet = this.buildWorksheet.bind(this);
        this.handleUserInput = this.handleUserInput.bind(this);
        this.changeWorksheetValue = this.changeWorksheetValue.bind(this);
        this.printWorksheet = this.printWorksheet.bind(this);
        this.getCurrentPage = this.getCurrentPage.bind(this);
        this.validateReviewableQuestion = this.validateReviewableQuestion.bind(this);
        this.changePage = this.changePage.bind(this);
        this.saveWorksheet = this.saveWorksheet.bind(this);
        this.saveAndCloseWorksheet = this.saveAndCloseWorksheet.bind(this);
        this.closeWorksheet = this.closeWorksheet.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
    }

    async componentDidMount() {
        await this.getWorksheet();
        await this.buildPages();
    }

    async buildPages() {
        const len = this.state.worksheet.masterSections.length;
        const sections = [...this.state.worksheet.masterSections];
        let pageCount = Math.ceil(len / 10);
        pageCount = pageCount === 0 ? 1 : pageCount;
        let currentPage = 0;
        let pages = [];
        var i;
        for (i = 0; i < pageCount; i++) {
            pages.push(sections.splice(0, 10));
        }
        this.setState({ pages: pages, currentPage: currentPage, pageCount: pageCount });
    }

    getCurrentPage() {
        if (this.state.pages[this.state.currentPage] !== undefined) {
            return this.state.pages[this.state.currentPage].map((section) => this.buildSection(section));
        }
        return null;
    }

    async saveAndCloseWorksheet() {
        var result = await this.saveWorksheet();
        // nav back
        if (result) {
            this.props.history.push('/coding/events/' + this.state.codingEventWorksheet.codingEventId);
        }
    }

    closeWorksheet() {
        this.props.history.push('/coding/events/' + this.state.codingEventWorksheet.codingEventId);
    }

    changeStatus(statusId) {
        let partialState = { ...this.state.codingEventWorksheet };
        partialState.status = statusId;
        this.setState({codingEventWorksheet: partialState}, async () => await this.saveWorksheet())
    }

    async saveWorksheet() {
        var eventService = new CodingWorksheetService();
        var eventId = this.state.codingEventWorksheet.id;
        const codingEventWorksheet = this.state.codingEventWorksheet;
        codingEventWorksheet.worksheet = this.state.worksheet;
        codingEventWorksheet.worksheetAnswers = this.state.worksheetAnswers;
        var callResult = await eventService.saveWorksheet(eventId, codingEventWorksheet);
        if (callResult.result) {
            let model = callResult.model;
            this.setState({
                codingEventWorksheet: model,
                worksheet: model.worksheet,
                worksheetAnswers: model.worksheetAnswers
            });
            return true;
        }
    }

    async getWorksheet() {
        if (this.props.match.params.id !== undefined) {
            var eventService = new CodingWorksheetService();
            var eventId = this.props.match.params.id;
            var callResult = await eventService.getWorksheet(eventId);

            if (callResult.result) {
                let vm = callResult.model.codingEventWorksheet;
                this.setState({
                    codingEventWorksheet: vm,
                    worksheet: vm.worksheet,
                    worksheetAnswers: vm.worksheetAnswers
                });
            }
        }
    }

    buildWorksheet() {
        if (this.state.pages.length > 0) {

            var page = this.state.pages[this.state.currentPage];
            var sections = page.map((section) => this.buildSection(section));

            return sections;
        }
        return null;
    }

    buildSection(section) {
        var partialState = this.state.worksheetAnswers;
        if (partialState[section.controlGroup] === undefined || partialState[section.controlGroup] === null) {
            partialState[section.controlGroup] = {Rationale: ''};

            this.setState({ worksheetAnswers: partialState });
        }
        if (section.reviewable) {
            return (
                <div>
                    <div className="title-header">{section.controlGroup}: {section.name}</div>
                    <Form.Row>
                        <Col>
                            <Form.Label><b>Initial</b></Form.Label> <br/>
                            {section.masterQuestions.map(
                                (question) => this.buildQuestion(question, section.controlGroup, 'Initial'))}
                        </Col>
                        <Col>
                            <Form.Label><b>Revised</b></Form.Label><br/>
                            {section.masterQuestions.map(
                                (question) => this.buildQuestion(question, section.controlGroup, 'Revised'))}
                        </Col>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} lg="12">
                            <Form.Label><b>Rationale</b></Form.Label> 
                            <Form.Control placeholder=""
                                as="textarea" rows="2"
                                name={section.controlGroup + ':Rationale'}
                                id={section.controlGroup + ':Rationale'}
                                value={this.state.worksheetAnswers[section.controlGroup]['Rationale']}
                                onChange={this.handleUserInput} />
                        </Form.Group>
                    </Form.Row>
                </div>
            );
        } else {
            return (
                <div>
                    <div className="title-header">{section.name}</div>
                    <Form.Row>
                        {section.masterQuestions.map((question) => this.buildQuestion(question, section.controlGroup, null))}
                    </Form.Row>
                </div>
            );
        }
    }

    buildQuestion(question, parentControlGroup, controlFieldName) {
        try {
            let Control = WorksheetControls[question.controlType];
            let parentName = parentControlGroup + ':' + question.controlGroup;
            if (controlFieldName !== null) {
                var partialState = this.state.worksheetAnswers;
                if (partialState[parentControlGroup][question.controlGroup] === undefined ||
                    partialState[parentControlGroup][question.controlGroup] === null) {
                    partialState[parentControlGroup][question.controlGroup] = {}
                    this.setState({ worksheetAnswers: partialState });
                }
                let controlName = parentName + ':' + controlFieldName;
                return (
                    <Control onChangeInput={this.handleUserInput}
                             parentControlGroup={parentControlGroup}
                             onBlur={() => this.validateReviewableQuestion(parentName)}
                             name={controlName}
                             error={this.state.worksheetAnswers[parentControlGroup][question.controlGroup]["error"]}
                             value={this.state.worksheetAnswers[parentControlGroup][question.controlGroup][controlFieldName]} {...question}/>
                );
            } else {
                const colLg = question.controlType === 'WorksheetTextarea' ? 12 : 4;
                const colMd = question.controlType === 'WorksheetTextarea' ? 12 : 6;
                return (
                    <Control onChangeInput={this.handleUserInput}
                             name={parentName}
                             colLg={colLg}
                             colMd={colMd}
                             parentControlGroup={parentControlGroup}
                             value={this.state.worksheetAnswers[parentControlGroup][question.controlGroup]} {...question}/>
                );
            }
        } catch (err) {
            return <Alert variant="danger">Error: {err.message} on loading control: {question.controlType} of questio {question.label}</Alert>
        }
    }

    validateReviewableQuestion(fieldPath) {

        var answers = this.state.worksheetAnswers;
        var selector = fieldPath.split(":");
        var errorValue = false;
        var touched = false;
        var newState = {};
        const controlGroup = stateHelpers.fetchState(answers, [...selector]);
        // if both the initial and revised are not undefined (both have values)
        // and they aren't empty
        // - and they are equal - then raise error
        const initial = controlGroup.Initial;
        const revised = controlGroup.Revised;
        if (initial !== undefined &&
            revised !== undefined &&
            initial !== "" &&
            initial === revised) {
            // error
            errorValue = true;
            touched = true;

        }
        // update the state with the errorValue
        //selector.push("error");
        let errorSelector = [...selector];
        errorSelector.push("error");
        answers = stateHelpers.updateState(answers, errorSelector, errorValue, false);
        let touchedSelector = [...selector];
        touchedSelector.push("touched");
        answers = stateHelpers.updateState(answers, touchedSelector, touched, false);
        this.setState({ worksheetAnswers: answers });
    }

    handleUserInput(event) {
        // taken straight from the React Docs
        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.changeWorksheetValue(name, value);
    }

    changeWorksheetValue(name, value) {
        const selectors = name.split(':');
        const answers = { ...this.state.worksheetAnswers };

        const newAnswers = stateHelpers.updateState(answers, [...selectors], value, false);

        // check to see if touched (and error) before - if so...
        this.setState({ worksheetAnswers: newAnswers }, () => {
            let touchedSelector = [...selectors];
            touchedSelector.pop();
            var controlGroup = stateHelpers.fetchState(newAnswers, [...touchedSelector]);
            if (controlGroup.touched && controlGroup.error) {
                this.validateReviewableQuestion(touchedSelector.join(":"));
            }
        });
    }

    async changePage(moveDir) {
        await this.saveWorksheet();
        var currentPage = this.state.currentPage;
        currentPage = currentPage + moveDir;
        this.setState({ currentPage: currentPage }, window.scrollTo(0, 0));
    }

    async printWorksheet() {
        await this.saveWorksheet();
        this.props.history.push({
            pathname: '/coding/worksheet/print',
            state: { worksheet: this.state.worksheet, worksheetAnswers: this.state.worksheetAnswers }
        });
    }

    render() {
        const status = this.state.codingEventWorksheet.status;
        return (

                <Card >
                    <Card.Header className="d-flex align-items-center">
                    <div className="mr-auto" >{this.state.worksheet.name} Worksheet</div>
                    <div className="card-btn-group">
                        <Button variant="secondary" size="sm" className={status === 0 ? "d-none" : null} onClick={() => this.printWorksheet()}>Print</Button>
                        <Button variant="warning" size="sm" className={status === 0 || status === 10 ? "d-none" : null} onClick={() => this.changeStatus(0)}>Cancel Worksheet</Button>
                        <Button variant="primary" size="sm" className={status === 0 || status === 10 ? "d-none" : null} onClick={() => this.changeStatus(10)}>Complete Worksheet</Button>
                        <Button variant="primary" size="sm" className={status === 5 || status === 1 ? "d-none" : null} onClick={() => this.changeStatus(5)}>Reset Status</Button>
                        {
                            status === 0 || status === 10 ?
                                <Button variant="success" size="sm" onClick={this.closeWorksheet}>Close</Button> :
                                <Dropdown as={ButtonGroup} size="sm" >
                                    <Button variant="success" onClick={this.saveAndCloseWorksheet}>Save & Close</Button>
                                    <Dropdown.Toggle  split variant="success" id="dropdown-split-basic" />
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={this.saveWorksheet}>Save</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                        }
                    </div>
                </Card.Header>
                <Card.Body>
                    <div>{this.getCurrentPage()}</div>
                    <Row>
                        <Form.Group as={Col}>
                            <Button size="lg" className="btn-block" style={this.state.currentPage <= 0 ? { display: 'none' } : {}} onClick={() => this.changePage(-1)}><FontAwesomeIcon icon={faCaretLeft} /> Previous Page</Button>
                        </Form.Group>
                        <Col className="d-flex justify-content-center align-items-center"><h5>Page {this.state.currentPage + 1} of {this.state.pageCount}</h5></Col>
                        <Form.Group as={Col}>
                            <Button size="lg" className="btn-block" style={this.state.currentPage >= (this.state.pageCount - 1) ? { display: 'none' } : {}} onClick={() => this.changePage(1)}>Next Page <FontAwesomeIcon icon={faCaretRight} /></Button>
                        </Form.Group>
                    </Row>

                    <div>
                            {
                                <pre>
                                {
                                    //JSON.stringify(this.state.worksheetAnswers, null, 2)
                                }
                                </pre>
                            }
                        </div>
                        <div>
                            {
                                <pre>
                                {
                                    //JSON.stringify(this.state.worksheet, null, 2)
                                }
                                </pre>
                            }
                    </div>
                    </Card.Body>
                </Card>
            );
    }

}

export default CodingWorksheet;